import React, { memo } from "react";

import type { IRegularBillingInfo } from "../../../hooks/reactQueryHooks/useBilling";
import { formatNumber } from "../../../utils/NumbersFormatting";
import { Badge } from "../../Badge/Badge";

interface IProps {
  billingData: IRegularBillingInfo;
}

const BillingBadgeRegular: React.FC<IProps> = memo(({ billingData }) => {
  const maxTokensCount = billingData
    ? Math.max(
        billingData.maxQuantityPerBillingPeriod,
        billingData.billingPeriodLimit,
      )
    : 0;

  return (
    <div className="sidebar-badge">
      <Badge
        variant={
          (billingData?.current || 0) >= maxTokensCount ? "danger" : "success"
        }
        size="sm"
        content={{
          value: `${formatNumber(billingData?.current || 0)} / ${formatNumber(
            maxTokensCount,
          )}`,
          title: "Cache items",
        }}
      />
    </div>
  );
});

export { BillingBadgeRegular };
